import React, { useEffect, useState } from "react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { useParams, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { api } from "@/lib/api";
import { Star, MapPin, ArrowRight, ShieldCheck } from "lucide-react";

const KantoorPubliekProfiel = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const [kantoor, setKantoor] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/kantoren/${id}`).then((r) => setKantoor(r.data)).finally(() => setLoading(false));
  }, [id]);

  if (loading) return <div className="min-h-screen flex items-center justify-center"><div className="w-6 h-6 border-2 border-[#F5A623] border-t-transparent rounded-full animate-spin" /></div>;
  if (!kantoor) return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <div className="flex-1 max-w-3xl mx-auto px-4 py-20 text-center">
        <h1 className="font-heading text-2xl font-bold">404</h1>
        <Link to="/" className="btn-outline-navy mt-6 inline-flex">{t("info_page.back_home")}</Link>
      </div>
      <Footer />
    </div>
  );

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <section className="bg-[#F8FAFC]">
        <div className="max-w-5xl mx-auto px-4 md:px-8 py-12">
          <Link to="/" className="text-sm text-slate-500 hover:text-[#1A2B4A]">← {t("common.back")}</Link>
          <div className="mt-6 beecenter-card p-8">
            <div className="flex items-start gap-6 flex-wrap">
              <div className="w-24 h-24 rounded-2xl overflow-hidden ring-1 ring-slate-200 flex-shrink-0">
                {kantoor.logo_url ? <img src={kantoor.logo_url} alt={kantoor.naam} className="w-full h-full object-cover" /> :
                  <div className="w-full h-full bg-[#1A2B4A] text-white flex items-center justify-center font-bold text-3xl">{kantoor.naam[0]}</div>}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <h1 className="font-heading text-3xl md:text-4xl font-bold text-[#1A2B4A]">{kantoor.naam}</h1>
                  {kantoor.verified && (
                    <span className="inline-flex items-center gap-1 pill-amber"><ShieldCheck size={12} /> {t("home.hero.trust_verified")}</span>
                  )}
                </div>
                <div className="flex items-center gap-4 mt-2 text-sm">
                  <span className="flex items-center gap-1 font-semibold text-[#1A2B4A]">
                    <Star size={14} className="fill-[#F5A623] text-[#F5A623]" />
                    {kantoor.rating?.toFixed(1)} <span className="text-slate-500 font-normal">({kantoor.reviews_count} {t("kantoor_card.reviews")})</span>
                  </span>
                  <span className="flex items-center gap-1 text-slate-600">
                    <MapPin size={14} /> {kantoor.locatie}
                  </span>
                </div>
                <p className="mt-4 text-slate-700 leading-relaxed">{kantoor.beschrijving}</p>
                <div className="flex flex-wrap gap-2 mt-5">
                  {(kantoor.specialismes || []).map((s) => <span key={s} className="pill-amber">{s}</span>)}
                </div>
              </div>
            </div>
          </div>

          <div className="mt-6 beecenter-card p-8 text-center">
            <h2 className="font-heading text-2xl font-bold text-[#1A2B4A]">{t("home.cta.title")}</h2>
            <p className="text-slate-600 mt-2">{t("home.cta.subtitle")}</p>
            <Link to="/onboarding" className="btn-amber mt-5 inline-flex" data-testid="kantoor-detail-cta">
              {t("home.cta.primary")} <ArrowRight size={16} />
            </Link>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default KantoorPubliekProfiel;
